import type {RuntimeConfig} from 'nuxt/schema'

function _deepFreeze(object): Pick<RuntimeConfig, 'api' | 'gpBaseUrl' | 'public'> {
    const propNames = Object.getOwnPropertyNames(object)
    for (const name of propNames) {
        const value = object[name]
        if (value && typeof value === 'object') {
            _deepFreeze(value)
        }
    }
    return Object.freeze(object)
}

export default defineNuxtPlugin(async () => {
    if (import.meta.server) {
        const {default: getRuntimeConfig} = await import('~src/runtime.config')
        const conf = getRuntimeConfig()
        useState('conf', () => shallowRef({public: conf.public}))
        return {provide: {conf: _deepFreeze(conf)}}
    } else {
        const conf = useState('conf', () => shallowRef())
        return {provide: {conf: _deepFreeze({public: conf.value.public})}}
    }
})
